import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

// Fractional-index moves, same shape as the question reorder endpoint: each
// move places scenario `id` next to one sibling. Supply exactly one of
// `afterId` / `beforeId` — the server rejects both together. `beforeId` is what
// moves a scenario to the front (there is no sibling to sit after).
export interface CBQScenarioMove {
  id: string;
  afterId?: string | null;
  beforeId?: string | null;
}

type ReorderCBQScenariosResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: unknown;
};

export const ReorderCBQScenarios = async (
  examId: string,
  moves: CBQScenarioMove[]
): Promise<ReorderCBQScenariosResponse> => {
  try {
    const response = await axios.post(
      `/admin/cbq/exams/${examId}/scenarios/reorder`,
      { moves }
    );
    return { data: response.data?.data ?? response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
